const breakCoordinatesModalReducer = (data = {coordinates:[], show:false}, action) => {
    switch(action.type){
        case 'SET_BREAK_COORDINATES_MODAL':
            data = action.data;
            return data;
        default:
            return data;
    }
}

export default breakCoordinatesModalReducer;